import { render, staticRenderFns } from "./NewInstantMedication.vue?vue&type=template&id=71496031&scoped=true"
import script from "./NewInstantMedication.vue?vue&type=script&lang=js"
export * from "./NewInstantMedication.vue?vue&type=script&lang=js"
import style0 from "./NewInstantMedication.vue?vue&type=style&index=0&id=71496031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71496031",
  null
  
)

export default component.exports